<template>
  <section class="passe-livre">
    <v-form ref="form" lazy-validation @submit.prevent="onSubmit">
      <v-card outlined class="app-card">
        <v-card-title class="app-card-title">Confirmar - Passe Livre Intermunicipal</v-card-title>
        <v-card-text class="app-card-content">
          <ul class="breadcrumbs-register">
            <li class="breadcrumbs-register__item">1 - Beneficiário</li>
            <li class="breadcrumbs-register__item breadcrumbs-register__item--active">
              2 - Confirmar
            </li>
          </ul>
          <v-row>
            <v-col :md="12" :sm="12" :xs="12" cols="12">
              <v-alert text dense color="info" border="left">
                <h3 class="alert-title">Atenção</h3>
                <ol class="alert-list">
                  <li class="alert-list__item">Confirme abaixo os seus dados.</li>
                  <li class="alert-list__item">
                    Caso exista algum dado inconsistente, retorne ao cadastro e edite a informação.
                  </li>
                  <li class="alert-list__item">
                    Ao confirmar, seu processo será enviado para análise e não será mais permitido
                    alterar qualquer informação.
                  </li>
                </ol>
              </v-alert>
            </v-col>
            <v-col :md="12" :sm="12" :xs="12" cols="12">
              <v-text-field
                v-model="form.cpf"
                placeholder="Digite seu cpf"
                :readonly="true"
                label="CPF *"
                v-mask="'###.###.###-##'"
                filled
                rounded
                dense
              ></v-text-field>
            </v-col>
            <v-col :md="12" :sm="12" :xs="12" cols="12">
              <v-text-field
                v-model="form.nome"
                placeholder="Digite seu nome"
                :readonly="true"
                label="Nome Completo *"
                filled
                rounded
                dense
              ></v-text-field>
            </v-col>
            <v-col :md="12" :sm="12" :xs="12" cols="12">
              <v-text-field
                v-model="form.email"
                placeholder="Digite seu email"
                label="Email "
                :rules="[rules.email]"
                :readonly="true"
                filled
                rounded
                dense
              />
            </v-col>
            <v-col :md="8" :sm="8" :xs="12" cols="12">
              <v-text-field
                v-model="form.dataNascimento"
                placeholder="Ex.: 17/04/1976"
                label="Data Nascimento *"
                :readonly="true"
                v-mask="'##/##/####'"
                filled
                rounded
                dense
              ></v-text-field>
            </v-col>
            <v-col :md="4" :sm="4" :xs="12" cols="12">
              <label>Sexo * </label>
              <v-radio-group v-model="form.sexo" :readonly="true" row class="mt-0">
                <v-radio :key="1" :label="`Masculino`" :value="true"></v-radio>
                <v-radio :key="2" :label="`Feminino`" :value="false"></v-radio>
              </v-radio-group>
            </v-col>
            <v-col :md="6" :sm="6" :xs="12" cols="12">
              <v-text-field
                v-model="form.numeroDocumento"
                placeholder="Digite o número do documento"
                label="Documento"
                v-mask="'#####################'"
                :readonly="true"
                filled
                rounded
                dense
              ></v-text-field>
            </v-col>
            <v-col :md="6" :sm="6" :xs="12" cols="12">
              <v-text-field
                v-model="form.dataEmissaoDocumento"
                placeholder="Ex.: 18/04/1996"
                v-mask="'##/##/####'"
                label="Emissão Documento"
                :readonly="true"
                filled
                rounded
                dense
              ></v-text-field>
            </v-col>
            <v-col :md="6" :sm="6" :xs="12" cols="12">
              <v-text-field
                v-model="form.orgaoEmissorDocumento"
                placeholder="Ex.: SSPDS"
                :readonly="true"
                label="Órgão Emissor"
                filled
                rounded
                dense
              ></v-text-field>
            </v-col>
            <v-col :md="6" :sm="6" :xs="12" cols="12">
              <v-text-field
                v-model="form.ufDocumento"
                :readonly="true"
                label="Uf Documento"
                placeholder="Selecione um Estado"
                filled
                rounded
                dense
              ></v-text-field>
            </v-col>
            <v-col :md="12" :sm="12" :xs="12" cols="12">
              <v-row>
                <v-col :md="2" :sm="2" :xs="2" cols="12">
                  <v-text-field
                    v-model="form.telefoneDdd"
                    placeholder="(85)"
                    label="DDD *"
                    :readonly="true"
                    v-mask="'(##)'"
                    filled
                    rounded
                    dense
                  ></v-text-field>
                </v-col>
                <v-col :md="4" :sm="4" :xs="4" cols="12">
                  <v-text-field
                    v-model="form.telefoneNum"
                    placeholder="99999-9999"
                    v-mask="'#####-####'"
                    label="Telefone *"
                    :readonly="true"
                    filled
                    rounded
                    dense
                  ></v-text-field>
                </v-col>
                <v-col :md="2" :sm="2" :xs="2" cols="12">
                  <v-text-field
                    v-model="form.telefoneDdd2"
                    placeholder="(85)"
                    label="DDD"
                    v-mask="'(##)'"
                    filled
                    rounded
                    dense
                  ></v-text-field>
                </v-col>
                <v-col :md="4" :sm="4" :xs="4" cols="12">
                  <v-text-field
                    v-model="form.telefoneNum2"
                    placeholder="99999-9999"
                    v-mask="'#####-####'"
                    label="Telefone "
                    filled
                    rounded
                    dense
                  ></v-text-field>
                </v-col>
              </v-row>
            </v-col>
            <v-col :md="12" :sm="12" :xs="12" cols="12">
              <v-text-field
                v-model="form.nomeMae"
                placeholder="Ex.: Digite o nome da Mãe"
                label="Nome da Mãe *"
                :readonly="true"
                filled
                rounded
                dense
              ></v-text-field>
            </v-col>
            <v-col :md="12" :sm="12" :xs="12" cols="12">
              <label>Necessita de Acompanhamente? *</label>
              <v-radio-group v-model="form.acompanhante" :readonly="true" row class="mt-0">
                <v-radio :key="3" :label="`Sim`" :value="true"></v-radio>
                <v-radio :key="4" :label="`Não`" :value="false"></v-radio>
              </v-radio-group>
            </v-col>
            <p class="red--text mb-0 ml-5">
              *Caso ocorra a necessidade do acompanhante, deverá constar no laudo médico a
              informação sobre o mesmo.
            </p>
          </v-row>
          <div class="loading" v-if="isLoading">
            <v-progress-circular :size="25" color="primary" indeterminate></v-progress-circular>
          </div>
        </v-card-text>
      </v-card>

      <v-card outlined class="app-card">
        <v-card-title class="app-card-title">Endereço</v-card-title>
        <v-card-text class="app-card-content">
          <v-row>
            <v-col :md="12" :sm="12" :xs="12" cols="12">
              <v-text-field
                v-model="form.cep"
                placeholder="Digite seu cep"
                label="Cep*"
                v-mask="'#####-###'"
                filled
                rounded
                :readonly="true"
                dense
                masked="false"
              ></v-text-field>
            </v-col>
            <v-col :md="9" :sm="9" :xs="9" cols="12">
              <v-text-field
                v-model="form.logradouro"
                placeholder="Ex.: Rua das Acácias"
                label="Logradouro *"
                :readonly="true"
                filled
                rounded
                dense
              ></v-text-field>
            </v-col>
            <v-col :md="3" :sm="3" :xs="3" cols="12">
              <v-text-field
                :readonly="true"
                :value="displayNumeroLogradouro"
                placeholder="Número Logradouro"
                label="Número "
                filled
                rounded
                dense
              ></v-text-field>
            </v-col>
            <v-col :md="6" :sm="6" :xs="6" cols="12">
              <v-text-field
                v-model="form.bairro"
                placeholder="Bairro"
                label="Bairro *"
                :readonly="true"
                filled
                rounded
                dense
              ></v-text-field>
            </v-col>
            <v-col :md="6" :sm="6" :xs="6" cols="12">
              <v-text-field
                v-model="form.municipio"
                label="Município*"
                placeholder="Selecione um Município"
                :readonly="true"
                filled
                rounded
                dense
              ></v-text-field>
            </v-col>
            <v-col :md="12" :sm="12" :xs="12" cols="12">
              <vue-recaptcha
                ref="recaptcha"
                :sitekey="siteKey"
                :loadRecaptchaScript="true"
                @verify="verifyRecaptcha"
                @expired="expiredRecaptcha"
              ></vue-recaptcha>
              <v-input v-model="form.recaptcha" :rules="[rules.required]"></v-input>
            </v-col>
          </v-row>
          <div class="loading" v-if="isLoading">
            <v-progress-circular :size="25" color="primary" indeterminate></v-progress-circular>
          </div>
        </v-card-text>
      </v-card>

      <v-row>
        <v-col :md="2">
          <v-btn outlined block large color="primary" type="button" @click="backToEdit()"
            >Editar</v-btn
          >
        </v-col>
        <v-col :md="2" :offset-md="8">
          <v-btn depressed block large color="primary" type="submit">Finalizar</v-btn>
        </v-col>
      </v-row>
    </v-form>
  </section>
</template>

<script>
import { mask } from 'vue-the-mask';
import { VUE_APP_RECAPTCHA_KEY } from '@/commons/config';
import BeneficiarioService from '@/services/beneficiario.service';
import BeneficiarioAuthService from '@/services/beneficiario.auth.service';
import EstadoService from '@/services/estado.service';
import MunicipioService from '@/services/municipio.service';
import BeneficiarioStore from '@/store/modules/beneficiario';
import moment from 'moment';
import GlobalStore from '@/store/modules/global';

import VueRecaptcha from 'vue-recaptcha';

export default {
  components: {
    VueRecaptcha,
  },
  directives: {
    mask,
  },
  data() {
    return {
      isLoading: false,
      siteKey: VUE_APP_RECAPTCHA_KEY,
      currentBeneficiarioId: null,
      currentProcessoId: null,
      estados: null,
      municipios: null,
      beneficiario: null,
      form: {
        cpf: null,
        nome: null,
        dataNascimento: null,
        sexo: null,
        numeroDocumento: null,
        dataEmissaoDocumento: null,
        orgaoEmissorDocumento: null,
        ufDocumento: null,
        telefoneDdd: null,
        telefoneNum: null,
        telefoneDdd2: null,
        telefoneNum2: null,
        nomeMae: null,
        acompanhante: null,
        cep: null,
        logradouro: null,
        numeroLogradouro: null,
        bairro: null,
        recaptcha: null,
        municipio: null,
        // telefones: [{ ddd: null, telefone: null }],
      },
      rules: {
        required: value => !!value || 'Esse campo deve ser preenchido',
      },
    };
  },
  computed: {
    displayNumeroLogradouro() {
      if (this.form.numeroLogradouro == 0) return 'S/N';
      if (this.form.numeroLogradouro == null || this.form.numeroLogradouro === undefined) return '';
      return this.form.numeroLogradouro;
    },
  },
  mounted() {
    this.loadEstados();
    this.setData();
    this.toTop();
  },
  methods: {
    loadBeneficiario() {
      const beneficiario = BeneficiarioAuthService.currentBeneficiarioValue();

      BeneficiarioAuthService.searchUser(beneficiario.cpf, beneficiario.dataNascimento).subscribe(
        res => {
          this.beneficiario = res;
          this.setForm();
        }
      );
    },
    toTop() {
      this.$vuetify.goTo(0);
    },
    setForm() {
      this.form.id = this.beneficiario.id;
      this.form.cpf = `${this.beneficiario.cpf}`;
      this.form.dataNascimento = moment(this.beneficiario.dataNascimento, 'YYYY-MM-DD').format(
        'DD/MM/YYYY'
      );
      this.form.nome = this.beneficiario.nome;
      this.form.sexo = this.beneficiario.sexo == 1 ? true : false;
      this.form.numeroDocumento = this.beneficiario.numeroDocumento;
      const estado = this.estados.find(estado => estado.nome === this.beneficiario.ufDocumento);
      this.form.ufDocumento = estado ? estado.nome : '';
      this.form.orgaoEmissorDocumento = this.beneficiario.orgaoEmissorDocumento;
      this.form.dataEmissaoDocumento = this.beneficiario.dataEmissaoDocumento
        ? moment(this.beneficiario.dataEmissaoDocumento, 'YYYY-MM-DD').format('DD/MM/YYYY')
        : '';

      this.form.telefoneDdd =
        this.beneficiario.dddTelefone ?? this.beneficiario.telefoneDdd ?? null;
      this.form.telefoneNum = this.beneficiario.telefone ?? this.beneficiario.telefoneNum ?? null;

      const t2 =
        Array.isArray(this.beneficiario.telefones) && this.beneficiario.telefones.length
          ? this.beneficiario.telefones[0]
          : null;

      this.form.telefoneDdd2 =
        String(this.beneficiario.dddTelefone2 ?? this.beneficiario.telefoneDdd2 ?? t2?.ddd ?? '') ||
        null;

      this.form.telefoneNum2 =
        String(
          this.beneficiario.telefone2 ?? this.beneficiario.telefoneNum2 ?? t2?.telefone ?? ''
        ) || null;
      this.form.nomeMae = this.beneficiario.nomeMae;
      this.form.acompanhante = this.beneficiario.acompanhante;

      this.form.cep = this.beneficiario.cep;
      this.form.logradouro = this.beneficiario.logradouro;
      this.form.numeroLogradouro = this.beneficiario.numeroLogradouro;
      this.form.bairro = this.beneficiario.bairro;

      this.form.email = this.beneficiario.email;

      const municipio = this.municipios.find(
        municipio => Number(municipio.id) == Number(this.beneficiario.municipioId)
      );
      this.form.municipio = municipio ? municipio.nome : '';

      this.form.telefones = this.beneficiario.telefones;
    },
    backToEdit() {
      this.$router.push({
        name: 'passe-livre-edit-cadastro',
        params: {
          id: this.currentBeneficiarioId,
          processo: this.currentProcessoId,
        },
      });
    },
    setData() {
      const { id, processo } = this.$route.params;
      this.currentBeneficiarioId = id;
      this.currentProcessoId = processo;
    },
    loadEstados() {
      BeneficiarioService.getAllEstados().subscribe(
        response => {
          this.estados = response;
          this.loadMunicipios();
        },
        error => {}
      );
    },
    loadMunicipios() {
      BeneficiarioService.getAllMunicipios().subscribe(
        response => {
          this.municipios = response;
          this.loadBeneficiario();
        },
        error => {}
      );
    },
    verifyRecaptcha(value) {
      this.form.recaptcha = value;
    },
    expiredRecaptcha() {
      this.$refs.recaptcha.reset();
      this.form.recaptcha = null;
    },
    onSubmit() {
      const isValid = this.$refs.form.validate();

      if (isValid) {
        this.isLoading = true;
        BeneficiarioService.updateAcompanhamentoProcesso(
          this.currentBeneficiarioId,
          this.currentProcessoId,
          2,
          this.form.recaptcha
        ).subscribe(
          response => {
            this.$router.push({
              name: 'passe-livre-detalhe',
              params: {
                id: this.currentBeneficiarioId,
              },
            });

            GlobalStore.setSnackBar({
              show: true,
              message: 'Cadastro Finalizado com sucesso!.',
              type: 'success',
            });
          },
          error => {}
        );
      }
    },
    searchCep(value) {
      this.subjectCep.next(value);
    },
    cepSubject() {
      this.subjectCep = new Subject();
      this.subjectCep
        .pipe(distinctUntilChanged())
        .pipe(tap(value => (this.isLoadingCep = true)))
        .pipe(
          switchMap(value => {
            const pattern = this.patternCep;
            const validCep = pattern.test(value);
            if (!validCep) {
              return of({ error: 'Cep invalido' });
            }
            return BeneficiarioService.find(value);
          })
        )
        .pipe(delay(500))
        .subscribe(
          res => {
            this.isLoadingCep = false;
            if (!res.error) {
              const { logradouro, uf, localidade, bairro, ibge } = res;

              if (logradouro) {
                this.form.logradouro = logradouro;
              }

              if (bairro) {
                this.form.bairro = bairro;
              }
              if (ibge) {
                this.form.municipioIbge = ibge;
              }

              if (localidade) {
                const municipio = this.municipios.filter(
                  mu => mu.nome === localidade.toUpperCase()
                );

                this.form.municipio.id = municipio[0].id;
              }
            }
          },
          error => {
            this.isLoadingCep = false;
          }
        );
    },
  },
};
</script>

<style scoped lang="scss">
.breadcrumbs-register {
  display: flex;
  align-items: center;
  justify-content: space-evenly;
  border-radius: 5px;
  padding: 0px;
  margin-bottom: 25px;

  &__item {
    padding: 10px;
    list-style: none;
    background-color: #ededed;
    display: flex;
    flex: 1;
    text-transform: uppercase;
    text-align: center;
    font-size: 17px;
    justify-content: center;
    color: #2e70b6;
    position: relative;
    padding-left: 30px;
    @media only screen and (max-width: 480px) {
      font-size: 13px !important;
    }
    &:last-child {
      margin-right: 13px;
    }
    &:after {
      position: absolute;
      display: block;
      border: 21px solid transparent;
      border-left: 16px solid #ededed;
      border-right: 0;
      top: 0px;
      z-index: 10;
      content: '';
      right: -15px;
    }
    &--active {
      background-color: #2e70b6;
      color: #fff;
      &:after {
        border-left-color: #2e70b6;
      }
    }
  }
}
.v-progress-circular {
  height: 22px !important;
  width: 22px !important;
  top: 16px !important;
}
.alert {
  &-title {
    margin: 0px 0px 5px;
    font-weight: 500 !important;
    font-size: 17px !important;
  }
  &-list {
    &__item {
      margin-bottom: 5px;
    }
  }
}
</style>
